module.exports = __webpack_public_path__ + "img/bike-ride-2-min.ec17bd3e.png";